<template>
  <div class="d-flex flex-column p-12px rounded border">
    <div class="font-size-500 text-neutral-300">Total Potential Inbound (40 Hari)</div>
    <Loader no-axios :loading="loading">
      <div class="text-xl">{{ $numeral(model.total).format("0,0") }}</div>
    </Loader>
  </div>
</template>

<script>
import Loader from "@/components/widgets/loader";
export default {
  components: {
    Loader
  },
  props: {},
  data() {
    return {
      model: {
        total: 0
      },
      loading: false
    };
  },
  mounted() {
    this.fetchModel();
  },
  methods: {
    handleResponse(response) {
      const {
        data: { meta }
      } = response;
      this.model.total = meta.potentional_inbound;
    },
    fetchModel() {
      this.loading = true;
      const today = this.$moment().format("YYYY-MM-DD");
      return this.$axios
        .get(`/account_receivable_projections?sort=date&date__gte=${today}`)
        .then(this.handleResponse)
        .catch(error => {
          this.failedAlert(error);
          return null;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.auditable {
  color: #6c7589;
  font-size: 8px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
</style>
